const axios = require('axios');
async function getLeagues(params) {
  try {
    const resData = await axios.get('/api/v1/admin/league/all', { params });
    return resData.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
}

async function findLeagueById(id) {
  try {
    const resData = await axios.get('/api/v1/admin/league', { params: { id } });
    return resData.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
}

async function updateLeague(params) {
  try {
    const resDate = await axios.put('/api/v1/admin/league', params);
    return resDate.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
}

async function creatLeague(params) {
  try {
    const resData = await axios.post('/api/v1/admin/league', params);
    return resData.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
}

async function deleteLeague(id) {
  try {
    const resData = await axios.delete('/api/v1/admin/league', { params: { id } });
    return resData.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
}

async function leagueReport({ id, page = 1 }) {
  try {
    const resData = await axios.get('/api/v1/admin/league/report', { params: { id, page } });
    return resData.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
}

async function changeUserScore({ leagueId, user, addScore }) {
  try {
    const resData = await axios.put('/api/v1/admin/league/score', { user, leagueId, addScore });
    return resData.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
}

module.exports = { getLeagues, findLeagueById, updateLeague, creatLeague, deleteLeague, leagueReport, changeUserScore };
